import {
  Grid,
  IconButton,
  LinearProgress,
  TextField,
  Tooltip,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  Autocomplete,
  CircularProgress,
  Box,
} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import InputMask from 'react-input-mask';

import { useLocation, useNavigate } from 'react-router-dom';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker, LocalizationProvider, ptBR } from '@mui/x-date-pickers';
import { FormHelperText, InputAdornment } from '@mui/material';
import { Container } from './CollaboratorForm.styled';
import { MdOutlineAssignmentReturn } from 'react-icons/md';
import { useCollaboratorService } from '../../../hooks/services/useCollaboratorService';
import { useToastrVanila } from '../../../hooks/util/useToastrVanila';
import { useValidateSchema } from '../../../hooks/providers/useValidateSchema';
import { LoadingButton } from '@mui/lab';
import { useCompanyService } from '../../../hooks/services/useCompanyService';
import { useSubsidiaryService } from '../../../hooks/services/useSubsidiaryService';
import { useLocalService } from '../../../hooks/services/useLocalService';
import { usePostService } from '../../../hooks/services/usePostService';
import { useWorkstationService } from '../../../hooks/services/useWorkstationService';

import PageTitle from '../../../components/page-title/PageTitle';
import IPage from '../../../interfaces/IPage';
import IEmployeeForm from '../../../interfaces/IEmployee';
import ICompany from '../../../interfaces/ICompany';
import ISubsidiary from '../../../interfaces/ISubsidiary';
import ILocal from '../../../interfaces/ILocal';
import IPost from '../../../interfaces/IPost';
import IWorkstation from '../../../interfaces/IWorkstation';
import moment from 'moment';
import * as yup from 'yup';
import IFormError from '../../../interfaces/IFormError';
import debounce from 'lodash.debounce';
import { useWorkShiftService } from '../../../hooks/services/useWorkShiftService';
import IWorkShift from '../../../interfaces/IWorkShift';
import ICostCenter from '../../../interfaces/ICostCenter';
import { useCostCenterService } from '../../../hooks/services/useCostCenterService';
import { hasAccessToAction } from '../../../util/hasAccessTo';
import UserContext from '../../../context/user/UserContext';

interface CollaboratorFormProps extends IPage { }

const initialEmployee: IEmployeeForm = {
  name: '',
  gender: '',
  cpf: '',
  birthday: '',
  admissionDate: '',
  demissionDate: '',
  city: '',
  state: '',
  type: '',
  code: '',
  email: '',
  phoneNumber: '',
  situation: 0,
  workstationHierarchy: '',

  company: {
    name: '',
    code: '',
  },
  subsidiary: {
    name: '',
    code: '',
  },
  local: {
    name: '',
    code: '',
  },
  post: {
    name: '',
    code: '',
  },
  workstation: {
    name: '',
    code: '',
  },
  workShift: {
    description: '',
    code: '',
  },
};
const types = [
  { value: 'EMPLOYEE', label: 'Funcionário' },
  { value: 'THIRD', label: 'Tercerizado' },
  { value: 'PARTNER', label: 'Parceiro' },
];
const situations = [
  { value: 1, label: '1 - Ativo' },
  { value: 2, label: '2 - Em processo' },
  { value: 7, label: '7 - Demitido' },
];
const Genders = [
  { value: 'F', label: 'F - Feminino' },
  { value: 'M', label: 'M - Masculino' },
];
const states = [
  'AC',
  'AL',
  'AM',
  'AP',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MG',
  'MS',
  'MT',
  'PA',
  'PB',
  'PE',
  'PI',
  'PR',
  'RJ',
  'RN',
  'RO',
  'RR',
  'RS',
  'SC',
  'SE',
  'SP',
  'TO',
];

const CollaboratorForm = (props: CollaboratorFormProps) => {
  window.document.title = props.title;
  //Colaborador
  const [employeeForm, setEmployeeForm] = useState<IEmployeeForm>(initialEmployee);

  //Const's para validação do input "empresa" do valor Company
  const [validateHifenCompany, setvalidateHifenCompany] = useState(false);
  const [inputValueCompany, setInputValueCompany] = useState('');
  const [optionsCompany, setOptionsCompany] = React.useState<readonly ICompany[]>([]);
  const [openCompany, setOpenCompany] = React.useState(false);
  const [loadingCompany, setLoadingCompany] = useState(false);

  //Const's para validação do input "filial" do valor Subsidiary
  const [validateHifenSubisidiary, setvalidateHifenSubsidiary] = useState(false);
  const [inputValueSubsidiary, setInputValueSubsidiary] = useState('');
  const [optionsSubsidiary, setOptionsSubsidiary] = React.useState<readonly ISubsidiary[]>([]);
  const [openSubsidiary, setOpenSubsidiary] = React.useState(false);
  const [loadingSubsidiary, setLoadingSubsidiary] = useState(false);

  //Const's para validação do "local" do valor Local
  const [validateHifenLocal, setvalidateHifenLocal] = useState(false);
  const [inputValueLocal, setInputValueLocal] = useState('');
  const [optionsLocal, setOptionsLocal] = React.useState<readonly ILocal[]>([]);
  const [openLocal, setOpenLocal] = React.useState(false);
  const [loadingLocal, setLoadingLocal] = useState(false);

  //Const's para validação do input "Função" do valor Post
  const [validateHifenPost, setvalidateHifenPost] = useState(false);
  const [inputValuePost, setInputValuePost] = useState('');
  const [optionsPost, setOptionsPost] = React.useState<readonly IPost[]>([]);
  const [openPost, setOpenPost] = React.useState(false);
  const [loadingPost, setLoadingPost] = useState(false);

  //Const's para validação do input "Setor de trabalho" do valor Workstation
  const [validateHifenWorkstation, setvalidateHifenWorkstation] = useState(false);
  const [inputValueWorkstation, setInputValueWorkstation] = useState('');
  const [optionsWorkstation, setOptionsWorkstation] = React.useState<readonly IWorkstation[]>([]);
  const [openWorkstation, setOpenWorkstation] = React.useState(false);
  const [loadingWorkstation, setLoadingWorkstation] = useState(false);

  //Const's para validação do input "Escala de trabalho" do valor WorkShift

  const [validateHifenWorkShift, setvalidateHifenWorkShift] = useState(false);
  const [inputValueWorkShift, setInputValueWorkShift] = useState('');
  const [optionsWorkShift, setOptionsWorkShift] = React.useState<readonly IWorkShift[]>([]);
  const [openWorkShift, setOpenWorkShift] = React.useState(false);
  const [loadingWorkShift, setLoadingWorkShift] = useState(false);

  //const's para manipular os estados de listagem no input's de auto complete
  const [currentCompany, setCurrentCompany] = React.useState<ICompany | undefined>(employeeForm?.company || undefined);
  const [currentSubsidiary, setCurrentSubsidiary] = React.useState<ISubsidiary | undefined>(
    employeeForm?.subsidiary || undefined,
  );
  const [currentLocal, setCurrentLocal] = React.useState<ILocal | undefined>(employeeForm?.subsidiary || undefined);
  const [currentPost, setCurrentPost] = React.useState<IPost | undefined>(employeeForm?.subsidiary || undefined);
  const [currentWorkstation, setCurrentWorkstation] = React.useState<IWorkstation | undefined>(
    employeeForm?.subsidiary || undefined,
  );
  const [currentWorkShift, setCurrentWorkShift] = React.useState<IWorkShift | undefined>(
    employeeForm?.workShift || undefined,
  );

  const [openCostCenter, setOpenCostCenter] = useState(false);
  const [optionsCostCenter, setOptionsCostCenter] = useState<ICostCenter[]>([]);
  const [loadingCostCenter, setLoadingCostCenter] = useState(false);
  const [currentCostCenter, setCurrentCostCenter] = useState<ICostCenter | null>(null);
  const [inputValueCostCenter, setInputValueCostCenter] = useState('');
  const [validateHifenCostCenter, setValidateHifenCostCenter] = useState(false);

  const [loading, setLoading] = useState(false);
  const [action, setAction] = useState<'edit' | 'new'>('edit');
  const [id, setId] = useState(0);
  const [errors, setErrors] = useState<IFormError | null>(null);
  const [actionLabel, setActionLabel] = useState('INCLUSÃO');

  const navigate = useNavigate();
  const location = useLocation();
  const request = useCollaboratorService();
  const requestCompany = useCompanyService();
  const requestSub = useSubsidiaryService();
  const requestLocal = useLocalService();
  const requestPost = usePostService();
  const requestWorks = useWorkstationService();
  const requestWorkShifts = useWorkShiftService();
  const requestCostCenters = useCostCenterService();
  const toastr = useToastrVanila();
  const validation = useValidateSchema();

  const { state } = useContext(UserContext);
  const { resourcesWithActions } = state;

  const schema = yup.object({
    code: yup.string().required('Campo obrigatório'),
    name: yup.string().required('Campo obrigatório'),
    cpf: yup.string().required('Campo obrigatório'),
    bithday: yup.string().required('Campo obrigatório'),
    admissionDate: yup.string().required('Campo obrigatório'),
    city: yup.string().required('Campo obrigatório'),
    state: yup.string().required('Campo obrigatório'),
    email: yup.string(),
    phoneNumber: yup.string(),
    workstationHierarchy: yup.string(),
    costCenter: yup.object({
      name: yup.string().required('Campo obrigatório'),
    }),
  });

  useEffect(() => {
    const action = location.pathname.split('/')[location.pathname.split('/').length - 1] as 'edit' | 'new';
    const id = parseInt(location.pathname.split('/')[location.pathname.split('/').length - 2]);
    setAction(action);
    if (action === 'edit') {
      setActionLabel('EDIÇÃO');
    } else {
      setActionLabel('INCLUSÃO');
    }
    setId(id);
    if (id !== 0) {
      listEmployeeByID(id);
    }
  }, []);

  const listEmployeeByID = async (id: number): Promise<void> => {
    setLoading(true);
    await request
      .listById(id)
      .then(result => {
        setLoading(false);
        setEmployeeForm({ ...result });
        setCurrentWorkShift(result.workShift);
        setCurrentCostCenter(result.costCenter ?? null);
      })
      .catch(error => {
        setLoading(false);
        toastr.error(error.message);
      });
  };

  const loadCompanies = debounce(async (filter = ' ') => {
    setLoadingCompany(true);
    await requestCompany
      .listCompanySearch(filter)
      .then(companies => {
        setOptionsCompany(companies);
        setLoadingCompany(false);
      })
      .catch(error => {
        toastr.error(`Erro ao carregar os dados: ${error.message}`);
        setLoadingCompany(false);
      });
  }, 500);

  const loadSubsidiaries = debounce(async (id: number) => {
    setLoadingSubsidiary(true);
    await requestSub
      .listSubsidiaryByCompanyId(id)
      .then(subsidiaries => {
        setOptionsSubsidiary(subsidiaries);
        setLoadingSubsidiary(false);
      })
      .catch(error => {
        toastr.error(`Erro ao carregar os dados: ${error.message}`);
        setLoadingSubsidiary(false);
      });
  }, 500);

  const loadLocations = debounce(async (id: number) => {
    setLoadingLocal(true);
    await requestLocal
      .listLocalBySubsidiaryId(id)
      .then(Locations => {
        setOptionsLocal(Locations);
        setLoadingLocal(false);
      })
      .catch(error => {
        toastr.error(`Erro ao carregar os dados: ${error.message}`);
        setLoadingLocal(false);
      });
  }, 500);

  const loadPosts = debounce(async (id: number) => {
    setLoadingPost(true);
    await requestPost
      .listPostBySubsidiaryId(id)
      .then(Posts => {
        setOptionsPost(Posts);
        setLoadingPost(false);
      })
      .catch(error => {
        toastr.error(`Erro ao carregar os dados: ${error.message}`);
        setLoadingPost(false);
      });
  }, 500);

  const loadWorkstations = debounce(async (filter = ' ') => {
    setLoadingWorkstation(true);
    await requestWorks
      .listWorkstationBySubsidiaryId(filter)
      .then(Works => {
        setOptionsWorkstation(Works);
        setLoadingWorkstation(false);
      })
      .catch(error => {
        toastr.error(`Erro ao carregar os dados: ${error.message}`);
        setLoadingPost(false);
      });
  }, 500);

  const loadWorkShifts = debounce(async () => {
    setLoadingWorkShift(true);
    await requestWorkShifts
      .listWorkShiftSearch(' ')
      .then(Works => {
        setOptionsWorkShift(Works);
        setLoadingWorkShift(false);
      })
      .catch(error => {
        toastr.error(`Erro ao carregar os dados: ${error.message}`);
        setLoadingWorkShift(false);
      });
  }, 500);

  const loadCostCenters = debounce(async () => {
    setLoadingCostCenter(true);
    await requestCostCenters
      .listCostCenter()
      .then(costCenter => {
        setOptionsCostCenter(costCenter || []);
        setLoadingCostCenter(false);
      })
      .catch(error => {
        toastr.error(`Erro ao carregar os dados: ${error.message}`);
        setLoadingCostCenter(false);
      });
  }, 500);


  const separateTwo = (variavel: string) => {
    // Função para remover espaços antes e depois dos elementos antes de dividir
    const dividirStringPorHifen = (stringParaDividir: string): string[] => {
      // Remover espaços ao redor de cada parte dividida
      return stringParaDividir.split('-').map(part => part.trim());
    };

    const partesDivididas = dividirStringPorHifen(variavel);
    return partesDivididas;
  };

  const createCollaborator = async (employeeForm: IEmployeeForm): Promise<void> => {
    setLoading(true);
    await request
      .create({ ...employeeForm })
      .then(result => {
        setLoading(false);
        setEmployeeForm({ ...result });
        toastr.success('Colaborador cadastrado com sucesso! ');
        navigate(`/collaborator`);
      })
      .catch(error => {
        setLoading(false);
        toastr.error('Não foi possivel cadastrar colaborador');
        toastr.error(error.message);
      });
  };
  const UpdateCollaborator = async (id: number, employeeForm: IEmployeeForm): Promise<void> => {
    delete employeeForm.leaderId;
    setLoading(true);
    await request
      .update(id, employeeForm)
      .then(result => {
        setLoading(false);
        setEmployeeForm({ ...result });
        toastr.success('colaborador atualizado com sucesso');
        navigate('/collaborator');
      })
      .catch(error => {
        setLoading(false);
        toastr.error(error.message);
      });
  };

  const handleCancel = async () => {
    if (action === 'edit') {
      listEmployeeByID(id);
    } else {
      setEmployeeForm({ ...initialEmployee });
    }
  };

  const handleSaveClick = async () => {
    const resource = { ...employeeForm };
    const result = await validation.validate(schema, resource);
    setErrors(result.errors);
    if (result.isValid) {
      return;
    }
    if (action === 'edit') {
      await UpdateCollaborator(id, resource);
    } else {
      await createCollaborator(resource);
    }
  };

  const isEdit = hasAccessToAction(
    ["colaboradores-atestado-web"],
    resourcesWithActions,
    "Editar"
  );

  return (
    <Container>
      <PageTitle title={`${actionLabel} DE COLABORADOR`}>
        <Tooltip title="voltar para a listagem" placement="left-start">
          <IconButton onClick={() => navigate(`/collaborator`)} color="inherit">
            <MdOutlineAssignmentReturn />
          </IconButton>
        </Tooltip>
      </PageTitle>
      {loading && <LinearProgress />}
      <br />
      <form>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              placeholder="Informe o Código do Colaborador"
              label="Código do colaborador "
              disabled={actionLabel === 'EDIÇÂO'}
              id="outlined-disabled"
              value={employeeForm.code}
              onChange={e =>
                setEmployeeForm({
                  ...employeeForm,
                  code: e.target.value,
                })
              }
              error={Boolean(errors?.code)}
              helperText={errors?.code}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    ></div>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Nome"
              placeholder="Informe o nome"
              value={employeeForm.name}
              onChange={e => setEmployeeForm({ ...employeeForm, name: e.target.value })}
              error={Boolean(errors?.name)}
              helperText={errors?.name}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth error={Boolean(errors?.error)}>
              <InputLabel id="professional-state">Gênero</InputLabel>
              <Select
                labelId="gender"
                id="gender-select"
                value={employeeForm.gender || ''}
                label="Informe o Gênero"
                onChange={e => setEmployeeForm({ ...employeeForm, gender: e.target.value })}
                MenuProps={{ sx: { maxHeight: '300px' } }}
              >
                {Genders.map((gender, i) => {
                  return (
                    <MenuItem value={gender.value} key={i}>
                      {gender.label}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText>{errors?.gender}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="CPF"
              placeholder="Informe o CPF "
              value={employeeForm.cpf}
              onChange={e => setEmployeeForm({ ...employeeForm, cpf: e.target.value })}
              error={Boolean(errors?.cpf)}
              helperText={errors?.cpf}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              type="email"
              fullWidth
              label="Email"
              placeholder="Informe o Email "
              value={employeeForm.email}
              onChange={e => setEmployeeForm({ ...employeeForm, email: e.target.value })}
              error={Boolean(errors?.email)}
              helperText={errors?.email}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputMask
              mask={'(99) 9 9999-9999'}
              value={employeeForm.phoneNumber}
              onChange={e => setEmployeeForm({ ...employeeForm, phoneNumber: e.target.value })}
              maskPlaceholder={null}
            >
              <TextField
                fullWidth
                label="Número de telefone"
                placeholder="Informe o número de telefone"
                value={employeeForm.phoneNumber}
                error={Boolean(errors?.phoneNumber)}
                helperText={errors?.phoneNumber}
              />
            </InputMask>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth error={Boolean(errors?.professionalState)}>
              <InputLabel id="professional-state">Situação</InputLabel>
              <Select
                labelId="situation"
                type="number"
                id="professional-situatiom"
                value={employeeForm.situation || ''}
                label="Informe a Situação"
                onChange={e => setEmployeeForm({ ...employeeForm, situation: Number(e.target.value) })}
                MenuProps={{ sx: { maxHeight: '300px' } }}
              >
                {situations.map((situation, i) => {
                  return (
                    <MenuItem value={situation.value} key={i}>
                      {situation.label}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText>{errors?.professionalState}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
            >
              <DatePicker
                value={employeeForm.birthday}
                label="Data de Nascimento"
                onChange={e => {
                  setEmployeeForm({ ...employeeForm, birthday: moment(e).format('yyyy-MM-DD') });
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    fullWidth
                    error={Boolean(errors?.birthday)}
                    placeholder="Data de Nascimento"
                    helperText={errors?.birthday}
                    autoFocus
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={6}>
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
            >
              <DatePicker
                value={employeeForm.admissionDate}
                label="Data de Admissão"
                onChange={e => {
                  setEmployeeForm({ ...employeeForm, admissionDate: moment(e).format('yyyy-MM-DD') });
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    fullWidth
                    error={Boolean(errors?.admissionDate)}
                    placeholder="Data de Admissão"
                    helperText={errors?.admissionDate}
                    autoFocus
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          {employeeForm.situation !== 7 ? (
            (employeeForm.demissionDate = undefined)
          ) : (
            <Grid item xs={12} md={6}>
              <LocalizationProvider
                dateAdapter={AdapterMoment}
                localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
              >
                <DatePicker
                  value={employeeForm.demissionDate}
                  label="Data de Demissão"
                  onChange={e => {
                    setEmployeeForm({ ...employeeForm, demissionDate: moment(e).format('yyyy-MM-DD') });
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      fullWidth
                      error={Boolean(errors?.demissionDate)}
                      placeholder="Data de Demissão"
                      helperText={errors?.demissionDate}
                      autoFocus
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          )}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Cidade"
              placeholder="Informe a cidade"
              value={employeeForm.city}
              onChange={e => setEmployeeForm({ ...employeeForm, city: e.target.value })}
              error={Boolean(errors?.city)}
              helperText={errors?.city}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth error={Boolean(errors?.professionalState)}>
              <InputLabel id="professional-state">Estado</InputLabel>
              <Select
                labelId="professional-state"
                id="professional-state-select"
                value={employeeForm.state || ''}
                label="Informe o Estado"
                onChange={e => setEmployeeForm({ ...employeeForm, state: e.target.value })}
                MenuProps={{ sx: { maxHeight: '300px' } }}
              >
                {states.map((state, i) => {
                  return (
                    <MenuItem value={state} key={i}>
                      {state}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText>{errors?.professionalState}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth error={Boolean(errors?.type)}>
              <InputLabel id="professional-state">Tipo de Colaborador</InputLabel>
              <Select
                labelId="type"
                id="type-select"
                value={employeeForm.type || ''}
                label="Informe o Tipo de Colaborador"
                onChange={e => setEmployeeForm({ ...employeeForm, type: e.target.value })}
                MenuProps={{ sx: { maxHeight: '300px' } }}
              >
                {types.map((type, i) => {
                  return (
                    <MenuItem value={type.value} key={i}>
                      {type.label}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText>{errors?.professionalState}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <Autocomplete
              open={openCompany}
              value={currentCompany?.name === '' ? employeeForm?.company : currentCompany}
              onInputChange={event => {
                setInputValueCompany('');
                loadCompanies([]);
                setvalidateHifenCompany(false);
                if (!currentCompany?.name) {
                  setCurrentCompany({
                    name: '',
                    code: '',
                  });
                }
              }}
              onChange={(e: any, newValue: ICompany | null) => {
                setCurrentCompany({
                  id: newValue?.id ?? undefined,
                  name: newValue?.name ?? '',
                  code: newValue?.code ?? '',
                });
                setEmployeeForm({
                  ...employeeForm,
                  company: {
                    id: newValue?.id ?? undefined,
                    name: newValue?.name ?? '',
                    code: newValue?.code ?? '',
                  },
                });
              }}
              onOpen={() => {
                setOpenCompany(true);
                setvalidateHifenCompany(false);
              }}
              onClose={() => {
                setOpenCompany(false);
              }}
              isOptionEqualToValue={(option: IEmployeeForm, value: ICompany) => {
                return option?.name === value?.name;
              }}
              renderOption={(props, option) => (
                <li {...props}>
                  <Box>
                    <span>{option ? `${option?.code} - ${option?.name}` : ''}</span>
                  </Box>
                </li>
              )}
              getOptionLabel={option => (option?.code ? `${option.code} - ${option.name}` : `${inputValueCompany}`)}
              options={optionsCompany}
              loading={loadingCompany}
              renderInput={params => (
                <TextField
                  {...params}
                  value={inputValueCompany}
                  label="Empresa"
                  error={Boolean(errors?.name)}
                  helperText={errors?.name}
                  size="medium"
                  onFocus={() => {
                    loadCompanies([]);
                    // setCurrentCompany({
                    //   name: '',
                    //   code: '',
                    // });
                  }}
                  onChange={event => {
                    setInputValueCompany(event.target.value);
                    loadCompanies(event.target.value);
                    setOptionsCompany([]);
                    if (event.target.value.search('-') > 0) {
                      setvalidateHifenCompany(true);
                    }
                    setEmployeeForm({
                      ...employeeForm,
                      company: {
                        name: '',
                        code: '',
                      },
                    });
                  }}
                  onBlur={e => {
                    if (validateHifenCompany) {
                      const teste = separateTwo(inputValueCompany);
                      const name = teste[1];
                      const code = teste[0];
                      setCurrentCompany({
                        name: name,
                        code: code,
                      });
                      setEmployeeForm({
                        ...employeeForm,
                        company: {
                          name: name,
                          code: code,
                        },
                      });
                    }
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loadingCompany ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Autocomplete
              open={openSubsidiary}
              value={currentSubsidiary?.name === '' ? employeeForm?.subsidiary : currentSubsidiary}
              onInputChange={event => {
                setInputValueSubsidiary('');
                if (currentCompany?.id !== undefined) {
                  loadSubsidiaries(currentCompany?.id);
                }
                if (employeeForm?.companyId !== undefined) {
                  loadSubsidiaries(employeeForm?.companyId);
                }
                setvalidateHifenSubsidiary(false);
                if (!currentSubsidiary?.name) {
                  setCurrentSubsidiary({
                    name: '',
                    code: '',
                  });
                }
              }}
              onChange={(e: any, newValue: ISubsidiary | null) => {
                setCurrentSubsidiary({
                  id: newValue?.id ?? undefined,
                  name: newValue?.name ?? '',
                  code: newValue?.code ?? '',
                });
                setEmployeeForm({
                  ...employeeForm,
                  subsidiary: {
                    id: newValue?.id ?? undefined,
                    name: newValue?.name ?? '',
                    code: newValue?.code ?? '',
                  },
                });
              }}
              onOpen={() => {
                setOpenSubsidiary(true);
                setvalidateHifenSubsidiary(false);
              }}
              onClose={() => {
                setOpenSubsidiary(false);
              }}
              isOptionEqualToValue={(option, value) => {
                return option?.name === value?.name;
              }}
              renderOption={(props, option) => (
                <li {...props}>
                  <Box>
                    <span>{option ? `${option?.code} - ${option?.name}` : ''}</span>
                  </Box>
                </li>
              )}
              getOptionLabel={option => (option?.code ? `${option.code} - ${option.name}` : `${inputValueSubsidiary}`)}
              options={optionsSubsidiary}
              loading={loadingSubsidiary}
              renderInput={params => (
                <TextField
                  {...params}
                  value={inputValueSubsidiary}
                  label="Filial"
                  error={Boolean(errors?.name)}
                  helperText={errors?.name}
                  size="medium"
                  onFocus={() => {
                    setOptionsSubsidiary([]);
                    if (currentCompany?.id !== undefined) {
                      loadSubsidiaries(currentCompany.id);
                    }
                    if (employeeForm?.companyId !== undefined) {
                      loadSubsidiaries(employeeForm?.companyId);
                    }
                  }}
                  onChange={event => {
                    setInputValueSubsidiary(event.target.value);
                    setEmployeeForm({
                      ...employeeForm,
                      subsidiary: {
                        name: '',
                        code: '',
                      },
                    });
                    if (currentCompany?.id !== undefined) {
                      loadSubsidiaries(currentCompany?.id);
                    }
                    setOptionsSubsidiary([]);
                    if (event.target.value.search('-') > 0) {
                      setvalidateHifenSubsidiary(true);
                    }
                  }}
                  onBlur={e => {
                    if (validateHifenSubisidiary) {
                      const teste = separateTwo(inputValueSubsidiary);
                      const name = teste[1];
                      const code = teste[0];
                      setCurrentSubsidiary({
                        name: name,
                        code: code,
                      });
                      setEmployeeForm({
                        ...employeeForm,
                        subsidiary: {
                          name: name,
                          code: code,
                        },
                      });
                    }
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loadingSubsidiary ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Autocomplete
              open={openCostCenter}
              value={currentCostCenter?.name === '' ? employeeForm?.costCenter : currentCostCenter}
              onInputChange={() => {
                setInputValueCostCenter('');
                loadCostCenters();
                setValidateHifenCostCenter(false);

                if (!currentCostCenter?.name) {
                  setCurrentCostCenter({ name: '', code: '' });
                  setEmployeeForm({
                    ...employeeForm,
                    costCenter: { name: '', code: '' },
                  });
                }
              }}
              onChange={(_e: any, newValue: ICostCenter | null) => {
                const selectedValue = {
                  id: newValue?.id ?? undefined,
                  name: newValue?.name ?? '',
                  code: newValue?.code ?? '',
                };
                setCurrentCostCenter(selectedValue);
                setEmployeeForm({
                  ...employeeForm,
                  costCenter: selectedValue,
                });
              }}
              onOpen={() => {
                setOpenCostCenter(true);
                setValidateHifenCostCenter(false);
              }}
              onClose={() => setOpenCostCenter(false)}
              isOptionEqualToValue={(option, value) => option?.name === value?.name}
              renderOption={(props, option) => (
                <li {...props}>
                  <Box>
                    <span>{option ? `${option.code} - ${option.name}` : ''}</span>
                  </Box>
                </li>
              )}
              getOptionLabel={option =>
                option?.code ? `${option.code} - ${option.name}` : `${inputValueCostCenter}`
              }
              options={optionsCostCenter}
              loading={loadingCostCenter}
              renderInput={params => (
                <TextField
                  {...params}
                  value={inputValueCostCenter}
                  label="Centro de custo do colaborador"
                  placeholder="Informe o centro de custo do colaborador"
                  error={Boolean(errors?.costCenter)}
                  helperText={errors?.costCenter}
                  size="medium"
                  onFocus={() => {
                    setOptionsCostCenter([]);
                    loadCostCenters();
                  }}
                  onChange={event => {
                    const val = event.target.value;
                    setInputValueCostCenter(val);
                    setOptionsCostCenter([]);
                    setEmployeeForm({
                      ...employeeForm,
                      costCenter: { name: '', code: '' },
                    });
                    loadCostCenters();

                    if (val.search('-') > 0) {
                      setValidateHifenCostCenter(true);
                    }
                  }}
                  onBlur={() => {
                    if (validateHifenCostCenter) {
                      const partes = separateTwo(inputValueCostCenter);
                      const code = partes[0];
                      const name = partes[1];
                      setCurrentCostCenter({ name, code });
                      setEmployeeForm({
                        ...employeeForm,
                        costCenter: { name, code },
                      });
                    }
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loadingCostCenter ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Autocomplete
              open={openLocal}
              value={currentLocal?.name === '' ? employeeForm?.local : currentLocal}
              onInputChange={event => {
                setInputValueLocal('');
                if (currentSubsidiary?.id !== undefined) {
                  loadLocations(currentSubsidiary?.id);
                }
                if (employeeForm?.subsidiaryId !== undefined) {
                  loadLocations(employeeForm?.subsidiaryId);
                }
                setvalidateHifenLocal(false);
                if (!currentSubsidiary?.name) {
                  setCurrentLocal({
                    name: '',
                    code: '',
                  });
                }
              }}
              onChange={(e: any, newValue: ILocal | null) => {
                setCurrentLocal({
                  id: newValue?.id ?? undefined,
                  name: newValue?.name ?? '',
                  code: newValue?.code ?? '',
                });
                setEmployeeForm({
                  ...employeeForm,
                  local: {
                    id: newValue?.id ?? undefined,
                    name: newValue?.name ?? '',
                    code: newValue?.code ?? '',
                  },
                });
              }}
              onOpen={() => {
                setOpenLocal(true);
                setvalidateHifenLocal(false);
              }}
              onClose={() => {
                setOpenLocal(false);
              }}
              isOptionEqualToValue={(option, value) => {
                return option?.name === value?.name;
              }}
              renderOption={(props, option) => (
                <li {...props}>
                  <Box>
                    <span>{option ? `${option?.code} - ${option?.name}` : ''}</span>
                  </Box>
                </li>
              )}
              getOptionLabel={option => (option?.code ? `${option.code} - ${option.name}` : `${inputValueLocal}`)}
              options={optionsLocal}
              loading={loadingLocal}
              renderInput={params => (
                <TextField
                  {...params}
                  value={inputValueLocal}
                  label="Local"
                  error={Boolean(errors?.name)}
                  helperText={errors?.name}
                  size="medium"
                  onFocus={() => {
                    setOptionsLocal([]);
                    if (currentSubsidiary?.id !== undefined) {
                      loadLocations(currentSubsidiary?.id);
                    }
                    if (employeeForm?.subsidiary?.id !== undefined) {
                      loadPosts(employeeForm?.subsidiary?.id);
                    }
                  }}
                  onChange={event => {
                    setInputValueLocal(event.target.value);
                    setEmployeeForm({
                      ...employeeForm,
                      local: {
                        name: '',
                        code: '',
                      },
                    });
                    if (currentSubsidiary?.id !== undefined) {
                      loadLocations(currentSubsidiary?.id);
                    }
                    setOptionsLocal([]);
                    if (event.target.value.search('-') > 0) {
                      setvalidateHifenLocal(true);
                    }
                  }}
                  onBlur={e => {
                    if (validateHifenLocal) {
                      const teste = separateTwo(inputValueLocal);
                      const name = teste[1];
                      const code = teste[0];
                      setEmployeeForm({
                        ...employeeForm,
                        local: {
                          name: name,
                          code: code,
                        },
                      });
                      setCurrentLocal({
                        name: name,
                        code: code,
                      });
                    }
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loadingLocal ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Autocomplete
              open={openPost}
              value={currentPost?.name === '' ? employeeForm?.post : currentPost}
              onInputChange={event => {
                setInputValuePost('');
                if (currentSubsidiary?.id !== undefined) {
                  loadPosts(currentSubsidiary?.id);
                }
                if (employeeForm?.subsidiaryId !== undefined) {
                  loadPosts(employeeForm?.subsidiaryId);
                }
                setvalidateHifenPost(false);
                if (!currentPost?.name) {
                  setCurrentPost({
                    name: '',
                    code: '',
                  });
                }
              }}
              onChange={(e: any, newValue: IPost | null) => {
                setCurrentPost({
                  id: newValue?.id ?? undefined,
                  name: newValue?.name ?? '',
                  code: newValue?.code ?? '',
                });
                setEmployeeForm({
                  ...employeeForm,
                  post: {
                    id: newValue?.id ?? undefined,
                    name: newValue?.name ?? '',
                    code: newValue?.code ?? '',
                  },
                });
              }}
              onOpen={() => {
                setOpenPost(true);
                setvalidateHifenPost(false);
              }}
              onClose={() => {
                setOpenPost(false);
              }}
              isOptionEqualToValue={(option, value) => {
                return option?.name === value?.name;
              }}
              renderOption={(props, option) => (
                <li {...props}>
                  <Box>
                    <span>{option ? `${option?.code} - ${option?.name}` : ''}</span>
                  </Box>
                </li>
              )}
              getOptionLabel={option => (option?.code ? `${option.code} - ${option.name}` : `${inputValuePost}`)}
              options={optionsPost}
              loading={loadingPost}
              renderInput={params => (
                <TextField
                  {...params}
                  value={inputValuePost}
                  label="Cargo"
                  error={Boolean(errors?.name)}
                  helperText={errors?.name}
                  size="medium"
                  onFocus={() => {
                    setOptionsPost([]);
                    if (currentSubsidiary?.id !== undefined) {
                      loadPosts(currentSubsidiary.id);
                    }
                    if (employeeForm?.subsidiary?.id !== undefined) {
                      loadPosts(employeeForm?.subsidiary?.id);
                    }
                  }}
                  onChange={event => {
                    setInputValuePost(event.target.value);
                    setEmployeeForm({
                      ...employeeForm,
                      post: {
                        name: '',
                        code: '',
                      },
                    });
                    if (currentSubsidiary?.id !== undefined) {
                      loadPosts(currentSubsidiary?.id);
                    }
                    setOptionsPost([]);
                    if (event.target.value.search('-') > 0) {
                      setvalidateHifenPost(true);
                    }
                  }}
                  onBlur={e => {
                    if (validateHifenPost) {
                      const teste = separateTwo(inputValuePost);
                      const name = teste[1];
                      const code = teste[0];
                      setCurrentPost({
                        name: name,
                        code: code,
                      });
                      setEmployeeForm({
                        ...employeeForm,
                        post: {
                          name: name,
                          code: code,
                        },
                      });
                    }
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loadingPost ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Autocomplete
              open={openWorkstation}
              value={currentWorkstation?.name === '' ? employeeForm?.workstation : currentWorkstation}
              onInputChange={event => {
                setInputValueWorkstation('');
                if (currentSubsidiary?.id !== undefined) {
                  loadWorkstations(currentSubsidiary?.id);
                }
                if (employeeForm?.subsidiaryId !== undefined) {
                  loadWorkstations(employeeForm?.subsidiaryId);
                }
                setvalidateHifenWorkstation(false);
                if (!currentWorkstation?.name) {
                  setCurrentWorkstation({
                    name: '',
                    code: '',
                  });
                }
              }}
              onChange={(e: any, newValue: IWorkstation | null) => {
                setCurrentWorkstation({
                  id: newValue?.id ?? undefined,
                  name: newValue?.name ?? '',
                  code: newValue?.code ?? '',
                });
                setEmployeeForm({
                  ...employeeForm,
                  workstation: {
                    id: newValue?.id ?? undefined,
                    name: newValue?.name ?? '',
                    code: newValue?.code ?? '',
                  },
                });
              }}
              onOpen={() => {
                setOpenWorkstation(true);
                setvalidateHifenWorkstation(false);
              }}
              onClose={() => {
                setOpenWorkstation(false);
              }}
              isOptionEqualToValue={(option, value) => {
                return option?.name === value?.name;
              }}
              renderOption={(props, option) => (
                <li {...props}>
                  <Box>
                    <span>{option ? `${option?.code} - ${option?.name}` : ''}</span>
                  </Box>
                </li>
              )}
              getOptionLabel={option => (option?.code ? `${option.code} - ${option.name}` : `${inputValueWorkstation}`)}
              options={optionsWorkstation}
              loading={loadingWorkstation}
              renderInput={params => (
                <TextField
                  {...params}
                  value={setInputValueWorkstation}
                  label="Posto de Trabalho "
                  error={Boolean(errors?.name)}
                  helperText={errors?.name}
                  size="medium"
                  onFocus={() => {
                    setOptionsWorkstation([]);
                    if (currentSubsidiary?.id !== undefined) {
                      loadWorkstations(currentSubsidiary.id);
                    }
                    if (employeeForm?.subsidiary?.id !== undefined) {
                      loadWorkstations(employeeForm?.subsidiary?.id);
                    }
                  }}
                  onChange={event => {
                    setInputValueWorkstation(event.target.value);
                    setEmployeeForm({
                      ...employeeForm,
                      workstation: {
                        name: '',
                        code: '',
                      },
                    });
                    if (currentSubsidiary?.id !== undefined) {
                      loadWorkstations(currentSubsidiary?.id);
                    }
                    setOptionsWorkstation([]);
                    if (event.target.value.search('-') > 0) {
                      setvalidateHifenWorkstation(true);
                    }
                  }}
                  onBlur={e => {
                    if (validateHifenWorkstation) {
                      const teste = separateTwo(inputValueWorkstation);
                      const name = teste[1];
                      const code = teste[0];
                      setCurrentWorkstation({
                        name: name,
                        code: code,
                      });
                      setEmployeeForm({
                        ...employeeForm,
                        workstation: {
                          name: name,
                          code: code,
                        },
                      });
                    }
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loadingWorkstation ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Autocomplete
              open={openWorkShift}
              value={currentWorkShift?.description === '' ? employeeForm?.workShift : currentWorkShift}
              onInputChange={event => {
                setInputValueWorkShift('');

                loadWorkShifts();

                setvalidateHifenWorkShift(false);

                if (!currentWorkShift?.description) {
                  setCurrentWorkShift({
                    description: '',
                    code: '',
                  });
                  setEmployeeForm({
                    ...employeeForm,
                    workShift: {
                      description: '',
                      code: '',
                    },
                  });
                }
              }}
              onChange={(e: any, newValue: IWorkShift | null) => {
                const selectedValue = {
                  id: newValue?.id ?? undefined,
                  description: newValue?.description ?? '',
                  code: newValue?.code ?? '',
                };
                setCurrentWorkShift(selectedValue);
                setEmployeeForm({
                  ...employeeForm,
                  workShift: selectedValue,
                });
              }}
              onOpen={() => {
                setOpenWorkShift(true);
                setvalidateHifenWorkShift(false);
              }}
              onClose={() => {
                setOpenWorkShift(false);
              }}
              isOptionEqualToValue={(option, value) => {
                return option?.description === value?.description;
              }}
              renderOption={(props, option) => (
                <li {...props}>
                  <Box>
                    <span>{option ? `${option?.code} - ${option?.description}` : ''}</span>
                  </Box>
                </li>
              )}
              getOptionLabel={option =>
                option?.code ? `${option.code} - ${option.description}` : `${inputValueWorkShift}`
              }
              options={optionsWorkShift}
              loading={loadingWorkShift}
              renderInput={params => (
                <TextField
                  {...params}
                  value={inputValueWorkShift}
                  label="Escala de Trabalho"
                  error={Boolean(errors?.workShift)}
                  helperText={errors?.workShift}
                  size="medium"
                  onFocus={() => {
                    setOptionsWorkShift([]);
                    loadWorkShifts();
                  }}
                  onChange={event => {
                    const val = event.target.value;
                    setInputValueWorkShift(val);
                    setOptionsWorkShift([]);

                    setEmployeeForm({
                      ...employeeForm,
                      workShift: { description: '', code: '' },
                    });

                    loadWorkShifts();

                    if (val.search('-') > 0) {
                      setvalidateHifenWorkShift(true);
                    }
                  }}
                  onBlur={e => {
                    if (validateHifenWorkShift) {
                      const partes = separateTwo(inputValueWorkShift);
                      const code = partes[0];
                      const desc = partes[1];

                      // Atualizando ambos para garantir que o texto apareça no campo após o blur
                      setCurrentWorkShift({ description: desc, code: code });
                      setEmployeeForm({
                        ...employeeForm,
                        workShift: { description: desc, code: code },
                      });
                    }
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loadingWorkShift ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              placeholder="Informe a hierarquia do colaborador"
              label="Hierarquia do colaborador "
              value={employeeForm.workstationHierarchy}
              onChange={e =>
                setEmployeeForm({
                  ...employeeForm,
                  workstationHierarchy: e.target.value,
                })
              }
              error={Boolean(errors?.workstationHierarchy)}
              helperText={errors?.workstationHierarchy}
            />
          </Grid>

          <Grid item xs={12} md={6}></Grid>
        </Grid>
      </form>
      <Grid container direction="row" justifyContent="flex-start" alignItems="center" sx={{ marginTop: 5 }} spacing={2}>
        <Grid item>
          <LoadingButton loading={loading} variant="contained" color="secondary" onClick={handleCancel}>
            Cancelar
          </LoadingButton>
        </Grid>
        <Grid item>
          <LoadingButton loading={loading} variant="contained" color="primary" onClick={handleSaveClick} disabled={!isEdit}>
            Salvar
          </LoadingButton>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CollaboratorForm;
